import { render, staticRenderFns } from "./expense-export.vue?vue&type=template&id=513a00ee"
import script from "./expense-export.vue?vue&type=script&lang=js"
export * from "./expense-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports